<template>
  <el-footer id="myFooter" height="220px">
    <div class="wrapper">
      <el-row class="top">
        <el-col :span="8">
          <router-link to="/managestandard">Noosphere平台管理规范</router-link>
        </el-col>
        <el-col :span="8">
          <router-link to="/datastandard"
            >Noosphere数据规范与分享倡议</router-link
          >
        </el-col>
        <el-col :span="8">
          <router-link to="/disclaimer">Noosphere免责声明</router-link>
        </el-col>
      </el-row>
      <ul class="blogroll">
        <li>
          <span>友情链接：</span>
        </li>
        <li v-for="item in blogrollList" :key="item">
          <a :href="item.url" target="_blank">{{ item.name }}</a>
        </li>
      </ul>
      <el-row>
        <el-col :span="8" :offset="8">
          <a href="http://www.beian.miit.gov.cn/" target="_blank">
            京ICP备15034667号-4</a
          >
        </el-col>
      </el-row>
    </div>
  </el-footer>
</template>

<script>
export default {
  name: "myFooter",
  data() {
    return {
      blogrollList: [
        { name: "创客天下", url: "http://www.ckzone.cn/" },
        { name: "中关村人工智能创新服务平台", url: "http://www.zgc-ai.cn/" },
        { name: "中关村融合创新服务平台", url: "http://www.zgcjm.org/" },
        { name: "自动驾驶之家", url: "http://www.heredrive.com/" },
        { name: "人工智能媒体平台", url: "http://www.atyun.com/" },
        { name: "科技快报", url: "http://www.citreport.com/" },
        { name: "人工智能实验室", url: "http://www.ailab.cn/" },
        { name: "TOP数码", url: "http://www.zixuntop.com/" }
      ]
    };
  }
};
</script>

<style lang="less">
#myFooter {
  padding: 0;
  text-align: center;
  font-size: 14px;
  color: #8b8c8d;
  background: #373d41;

  .el-row {
    line-height: 28px;
    &.top {
      padding: 68px 0 30px;
      a {
        color: #e1e2e3;
      }
    }
  }
  .blogroll {
    display: flex;
    padding-bottom: 30px;
    justify-content: space-between;
    a:hover {
      color: #0579fb;
    }
  }
}
</style>
